import { render, staticRenderFns } from "./JobViewUserPermissionsCard.vue?vue&type=template&id=86cb6e7c"
import script from "./JobViewUserPermissionsCard.vue?vue&type=script&lang=js"
export * from "./JobViewUserPermissionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports